// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.5.228",
  "gitHash": "77f56829b346e3033a937762006e8354a5a27d01",
  "versionWithHash": "5.5.228-77f56829b346e3033a937762006e8354a5a27d01"
};
